import React from "react"
import PropTypes from "prop-types"
import { Cell } from "fixed-data-table-2"
import { connect } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'

import { VerticallyCenteredDiv } from  "sheets/components/style"
import { ToolTipCell } from "sheets/components/cells/DatumCell"
import PressImage from "sheets/components/PressImage"
import { pressDatumConnection } from "sheets/components/cells/cell-selectors/datum-cell-selectors"
import { cleanUpHtml } from "imports/desktopHelperFunctions"

/**
 * Renders a press contact datum cell. Includes a photo (or a microphone icon if it doesn't exist)
 * and the name of the press contact.
 */
export const PressDatumCell = ({
    datum,
    personName,
    shouldShowPersonImage,
    ...props
}) => {
    const name = cleanUpHtml(personName)
    return (
        <ToolTipCell
            text={name}
            cellWidth={props.width}
            cell={(
                <Cell {...props}>
                    <VerticallyCenteredDiv>
                        {shouldShowPersonImage && (
                            <PressImage
                                datum={datum}
                                personName={name}
                            />
                        )}
                        <span>{name}</span>
                    </VerticallyCenteredDiv>
                </Cell>
            )}
        />
    )
}

export default connect(pressDatumConnection)(PressDatumCell)

PressDatumCell.propTypes = {
    /** The data required for the cell */
    datum: ImmutablePropTypes.map.isRequired,
    /** The full name of the person */
    personName: PropTypes.string,
    /** whether or not the person's photo (or an icon) should be displayed */
    shouldShowPersonImage: PropTypes.bool,
    /** The width of the cell */
    width: PropTypes.number,
}
